var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Group_17",
    "data-name": "Group 17",
    viewBox: "0 0 15 3"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    className: "cls-1",
    "data-name": "Ellipse 1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    className: "cls-1",
    "data-name": "Ellipse 2",
    transform: "translate(6)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    className: "cls-1",
    "data-name": "Ellipse 3",
    transform: "translate(12)"
  })));
}
export default __webpack_public_path__ + "static/media/ic_dots.1461d7ff.svg";
export { SvgIcDots as ReactComponent };